import { selectIssueById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo, type MouseEventHandler, useCallback } from "react"

import { useViewGeometryOnMap } from "../../mapbox/hooks"
import { useAppSelector } from "../../store"
import type { ExtendableLinkProps } from "./typings"

interface IssueLinkProps extends ExtendableLinkProps {
	issueId: string
}

export const IssueLink = memo<IssueLinkProps>((props) => {
	const { issueId, ref, onClick, ...rest } = props

	const issue = useAppSelector(selectIssueById(issueId))

	if (!issue) {
		throw new Error(`Issue with id ${issueId} not found`)
	}

	const viewIssueOnMap = useViewGeometryOnMap()

	const handleClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
		(e) => {
			onClick?.(e)

			if (e.defaultPrevented) return

			viewIssueOnMap(issue.geo_marker!)
		},
		[issue, onClick, viewIssueOnMap],
	)

	const params = useCallback(
		(prev) => {
			return {
				...prev,
				issueId: issueId,
			}
		},
		[issueId],
	)

	return (
		<Link
			ref={ref}
			to="/$organizationId/$projectId/issues/$issueId"
			params={params}
			onClick={handleClick}
			{...rest}
		/>
	)
})
IssueLink.displayName = "IssueLink"
